import { render } from "./XIconSolidPhoneCall.vue?vue&type=template&id=7aeea9a0"
import script from "./XIconSolidPhoneCall.vue?vue&type=script&lang=js"
export * from "./XIconSolidPhoneCall.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidPhoneCall.vue"]])

export default __exports__